import {createSelector, createSlice, PayloadAction} from 'lowkey-component';

import {RootState} from '@store/rootReducer';

export interface PeopleState {
  occupation: string;
  intentionality: string;
  joinType: string;
}

const initialValues: PeopleState = {
  occupation: '',
  intentionality: '',
  joinType: '',
};

export const selectPeopleState = (state: RootState) => {
  return state.people;
};

const selectOccupation = createSelector(
  selectPeopleState,
  ({occupation}) => occupation,
);

const selectIntentionality = createSelector(
  selectPeopleState,
  ({intentionality}) => intentionality,
);
const selectJoinType = createSelector(
  selectPeopleState,
  ({joinType}) => joinType,
);

const peopleSlice = createSlice({
  initialValues,
  reducers: {
    occupationSaved: (state, action: PayloadAction<string>) => {
      state.occupation = action.payload;
    },
    intentionalitySaved: (state, action: PayloadAction<string>) => {
      state.intentionality = action.payload;
    },
    joinTypeSaved: (state, action: PayloadAction<string>) => {
      state.joinType = action.payload;
    },
  },
});

export const peopleSelectors = {
  selectOccupation,
  selectIntentionality,
  selectJoinType,
};

export const {occupationSaved, joinTypeSaved, intentionalitySaved} =
  peopleSlice.actions;

export const {getInitialValues} = peopleSlice;
export default peopleSlice.reducer;
